import appApi from '../../../../../api/app-api';
import externalExamGroupsStore from '../../../../../stores/external-exam-groups-store';
import { toast } from 'react-toastify';
import { displayErrorText } from '../../../../../api/errors/api-error-codes';

export const deleteExternalExamGroupOperation = async (
  groupId: number,
  setGroupId: (groupId: number | null) => any,
) => {
  try {
    setGroupId(groupId);

    const res = await appApi.deleteExternalExamGroup(groupId);

    if (res.data.errCode) {
      toast.warn(displayErrorText(res.data.errCode));
    } else {
      await externalExamGroupsStore.fetchGroups();
      toast.success('מקבץ נמחק בהצלחה');
    }

    setGroupId(null);
  } catch (e) {
    setGroupId(null);
    console.error(`deleteExternalExamGroupOperation failed: ${e}`);
  }
};
